import React from 'react'
import '../../assets/css/Dashboardsection.css'

function DashboardSection() {
    return (
        <div className='p-3'>
            <div className="d-flex align-items-center gap-3">
                <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Dashboard</p>
            </div>

            <div className='managebrand_box mt-3'>
                <h4 className='dashboard_head py-4 ps-4 m-0'>Dashboard</h4>
                <hr className='p-0 m-0'></hr>
                <main style={{color: ' rgb(71, 85, 105)'}} className='py-4 ps-4'>Your Dashboard</main>
            </div>
        </div>
    )
}

export default DashboardSection